import { IMyHome } from '../../types/myHome';

const initialState: IMyHome = {
  isMyHomePage: false,
  showTrap: false,
};

export const myHomeReducer = (state: IMyHome = initialState) => state;
